import axios from 'axios'
import { initShopeepayReporter, instrumentAxios } from '@shopeepay/reporter'

const KNOWN_ROUTES = [
  '/',
  '/#about',
  '/career',
  '/consumer',
  '/consumer#App',
  '/contact-us',
  '/download',
  '/faq',
  '/feature',
  '/merchant',
  '/privacy',
  '/register',
  '/terms',
]

initShopeepayReporter({
  region: 'sg',
  project: 'shopeepay-sg',
  knownRoutes: KNOWN_ROUTES,
})
instrumentAxios(axios, 'shopeepay-sg')
